'use client';
import React, { useEffect, useState } from 'react';
import { ImageObj } from '@custom-types/ImageObj.types';
import DynamicButton from '@components/DynamicButton';
import cn from './style.module.scss';

type Props = {
  t: any;
  registerButtonImage: ImageObj;
  scrollToId?: string;
};

export default function WildsLaunchFloatingButton(props: Props) {
  const { t, scrollToId } = props;
  const [isBottom, setIsBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      setIsBottom(
        scrollPosition <= window.innerHeight ||
          scrollPosition >= pageHeight - window.innerHeight
      );
    };

    handleScroll(); // Call on initial render
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`${cn.wildsLaunchFloatingButton} ${isBottom ? cn.wildsButtonNone : ''}`}
    >
      <DynamicButton
        backgroundImage={props.registerButtonImage?.url}
        className={cn.wildsLaunchFloatingItem}
        children={t['heroRegisterLabel']}
        scrollToId="wildsRegistrationID"
      />
    </div>
  );
}
